import { useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

import { roomRateAvailabilityQueryKeys } from './roomRateAvailabilityQueryKeys';

export function useGetRoomRateLengthsOfStay(
  propertyId: string | undefined,
  roomTypeId: string | undefined,
  roomRateId: string | undefined,
) {
  return useQuery<Array<App.RoomRateLengthsDay>>({
    queryKey: [
      ...roomRateAvailabilityQueryKeys.all,
      'lengthsOfStay',
      propertyId ?? '',
      roomTypeId ?? '',
      roomRateId ?? '',
    ],
    queryFn: async () =>
      (await ReservationService.getLengthsOfStay(propertyId, roomTypeId, roomRateId)).result?.dates ?? [],
    enabled: !!propertyId && !!roomTypeId && !!roomRateId,
  });
}
